module.exports = __webpack_public_path__ + "img/dashiji-2019.f75b0d16.jpg";